import { render } from "./ViewCee.vue?vue&type=template&id=b4b5f56c&scoped=true&ts=true"
import script from "./ViewCee.vue?vue&type=script&lang=ts"
export * from "./ViewCee.vue?vue&type=script&lang=ts"

import "./ViewCee.vue?vue&type=style&index=0&id=b4b5f56c&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b5f56c"]])

export default __exports__